import { useLocalSearchParams } from 'expo-router';
import { Platform, View } from 'react-native';
import { createStyleSheet, useStyles } from 'react-native-unistyles';

import Recharge from '@/components/recharge';

export default function RechargeScreen() {
  const { styles } = useStyles(stylesheet);
  const { id } = useLocalSearchParams();

  if (Platform.OS === 'web') {
    return null;
  }

  return (
    <View style={styles.container}>
      <Recharge id={id} />
    </View>
  );
}

const stylesheet = createStyleSheet((theme) => ({
  container: {
    flex: 1,
    backgroundColor: theme.colors.background_1,
  },
}));
